import React from "react";
import { TransProps } from "@lingui/react";

// Type
export type typeDashboardCartColumnTitle = {
  title: React.ReactElement<TransProps>;
};

// Component
export const ColumnTitle: React.FC<typeDashboardCartColumnTitle> = ({
  title,
}) => {
  return <div className="hidden sm:block font-medium text-sm">{title}</div>;
};
